import React, { useEffect } from "react";
import CheckProfileComponents from "../../components/Signup/CheckProfile.components";
import { CheckProfileData, checkProfileData2 } from "./CheckProfileData";
import ArrowWhite from "../../images/Svg/ArrowWhite.svg";
import hand from "../../images/Svg/checkProfle/Hand.svg";
import GoBack from "../../components/goBack/GoBack";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

const UpLayout = () => {
  return (
    <div>
      <h1 className="text-[#161616] text-[36px] title font-bold text-center lg:text-justify">
        Your profile looks awesome
      </h1>
      <p className=" text-[#161616] mt-[12px] text-center lg:text-justify">
        View them in the dApps below
      </p>
    </div>
  );
};

export default function CheckProfile() {
  const { deso } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { username } = GetDesoProfile();
  useEffect(() => {
    if (localStorage.getItem("credential")) {
    } else {
      navigate("/home");
    }
  }, [deso]);

  const finalCheckProfileData = CheckProfileData.concat(checkProfileData2);
  const handleDashboard = () => {
    pushGaEvent(
      gaEvents.CONNECT_SOCIAL_MEDIA_BUTTON_CLICKED_FROM_CHECK_PROFILE
    );
    window.location.href = "/dashboard";
  };

  return (
    <section>
      <div className="container mx-auto px-4 mt-[40px] mb-[40px] md:mb-[300px] sm:px-4 md:px-0 lg:px-16">
        <Helmet>
          <title>Setu - Check DeSo Profile </title>
          <meta
            name="description"
            content="Sync you content to Deso using Setu in real time"
          />
        </Helmet>{" "}
        <div className="mb-[20px]">
          <GoBack />
        </div>
        <div className="md:hidden">
          <UpLayout />
          <div className="mt-[20px] mb-[48px]">
            <Swiper
              slidesPerView={2}
              spaceBetween={6}
              breakpoints={{
                540: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 4,
                },
              }}
              navigation={true}
              className="mySwiper"
            >
              {finalCheckProfileData.map((data, index) => (
                <SwiperSlide key={index}>
                  <CheckProfileComponents
                    key={index}
                    username={username}
                    data={data}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="grid sm:grid-cols-1 md:grid-cols-2">
          <div></div>
          <div>
            <img className="mx-auto lg:mx-0" src={hand} alt="" />
          </div>
          <div className="mt-[20px] mb-[60px] hidden md:inline">
            <UpLayout />
            <div className="flex lg:flex-wrap gap-8 mt-[24px]">
              {CheckProfileData.map((data, index) => (
                <CheckProfileComponents
                  data={data}
                  key={index}
                  username={username}
                />
              ))}
            </div>
            <div className="flex flex-wrap gap-8 mt-[24px]">
              {checkProfileData2.map((data, index) => (
                <CheckProfileComponents
                  data={data}
                  key={index}
                  username={username}
                />
              ))}
            </div>
          </div>

          <div className="w-full mt-[20px] ">
            <h1 className="text-[#161616]  text-[36px]  font-bold mb-[16px] text-center lg:text-justify">
              Let’s make it even better!
            </h1>

            <p className="text-[#161616] text-center lg:text-justify">
              {" "}
              Connect your Social Media to begin syncing your content to Web
              3.0.
            </p>
            <div onClick={handleDashboard} className="button_hover">
              <div className="bg-blue rounded-[8px] cursor-pointor w-[280px] h-[56px] text-white flex items-center my-[40px] justify-center mx-auto lg:mx-0">
                <p className="text-[16px] pr-4"> Connect Social Media</p>{" "}
                <img src={ArrowWhite} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
